import type { Dispatch, SetStateAction } from 'react';
import type { InfiniteData, QueryClient } from '@tanstack/react-query';
import type { PlatformMessage } from '@liks/backend-svc-api/esm/models/index';
import type { ChatMessage } from '../../../types/chatMessage';
import { chatQueryKeys } from '../chatQueryKeys';

export function hasMessageId(
  message: PlatformMessage | null | undefined,
): message is PlatformMessage & { id: string } {
  return typeof message?.id === 'string' && message.id.length > 0;
}

export function sessionHasPersistedMessages(
  queryClient: QueryClient,
  sessionId: string,
): boolean {
  const data = queryClient.getQueryData<
    InfiniteData<Array<PlatformMessage & { id: string }>, number>
  >(chatQueryKeys.messages(sessionId));
  return data?.pages.some((page) => page.length > 0) ?? false;
}

export function clearOptimisticSessionMessages(
  setOptimisticMessagesBySessionId: Dispatch<
    SetStateAction<Record<string, ChatMessage[]>>
  >,
  sessionId: string,
): void {
  setOptimisticMessagesBySessionId((current) => {
    const next = { ...current };
    delete next[sessionId];
    return next;
  });
}
